import { z } from 'src/lib'
import { InstrumentoFields } from './instrumento-fields'
import { EntityWithIdFields } from 'src/types'
import { getEndpoint } from './httpWRM'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const instrumento = z
    .object({
        [InstrumentoFields.Excepcion]: z.string(),
        [InstrumentoFields.ValorNominal]: z.number(),
        [InstrumentoFields.CashValueUSD]: z.number(),
        [InstrumentoFields.Instrumento]: z.string(),
        [InstrumentoFields.DescOperacionLimiteTipo]: z.string()
    })
    .extend({
        [EntityWithIdFields.Id]: z.number()
    })

const schema = z.array(instrumento)

export type Instrumento = z.infer<typeof instrumento>
export type Instrumentos = z.infer<typeof schema>

export const getInstrumentos = (idOperacion: number): Promise<Instrumentos> => {
    const endpoint = getEndpoint(`${idOperacion}/limites`)

    return HttpAxiosRequest.get(endpoint)
        .then(response => {
            const parsed = schema.safeParse(response)

            if (!parsed.success) {
                console.error(parsed.error.issues)

                return Promise.reject('Error de validación.')
            }

            return parsed.data
        })
        .catch(error => {
            console.error(error)

            return Promise.reject('Error de red.')
        })
}
